<template>
  <div class="ai-alert">
    <div class="head f-b-c bg-white">
      <div class="title">Terms of Use</div>
      <el-button size="small" @click="$emit('close')">Close</el-button>
    </div>
    <div class="content bg-white">
      <div class="main">
        <h1>Terms of Use</h1>
        <h2>Welcome to Kaka Designer</h2>
        <div class="block">
          <div class="text">These Terms and Conditions of the Kaka Designer Services are a binding Terms and conditions and shall apply to access to and use of the Kaka Designer Services by the user. The user access to and use of the Kaka Designer Services implies that the user has read and accepted all these Terms and Conditions of the Kaka Designer Services. We therefore recommend that you review them frequently.</div>
          <div class="text">Kaka Designer is still in the stage of exploring the frontier of technology. When using Kaka Designer, please ensure that the uploaded pictures and custom input text do not infringe the rights and interests of others, and please do not input politically related or violating laws and regulations.</div>
        </div>
        <h2>Limitations of Use</h2>
        <div class="block">
          <div class="text">The User agrees not to upload any Input or use any Output to:</div>
          <div class="text">
            <p>1. Infringe, misappropriate, or violate the intellectual property and/or image rights or other rights of any third party;</p>
            <p>2. Generate harmful for any person or group, or violent imagery;</p>
            <p>3. Mislead anyone that the AI Generated Content is human-generated;</p>
            <p>4. Generate political content including for dissemination in electoral campaigns;</p>
            <p>5. Generate nudity or shocking content including obscene gestures or other profane subjects; and Slander, libel or to vilify a person, race, sex, culture, sexual orientation, religion, country, region, town, village or any other place, or any other human group.</p>
          </div>
          <div class="text">If we find an image that is hurtful or offensive, we will remove the image without notifying you.</div>
          <div class="text">In the event that any of the Input or Output is alleged to be unlawful or otherwise in breach of these Terms, the User acknowledges that KAKACLO Company may disclose such content to law enforcement or other governmental authorities, or in response to a court order. Likewise, the breach of these Terms shall entitle KAKACLO Company to suspend or ban the User’s account.</div>
        </div>
        <h2>Generated Content License</h2>
        <div class="block">
          <div class="text">All content generated by Kaka Designer belongs to the user and KakaClo; you may use them for any legal purpose you wish.</div>
          <div class="text">It should be noted that because the model uses a large number of picture materials as samples for machine learning, the pictures generated when users specify a certain feature may be similar to some brands of clothes, which may cause potential disputes. Therefore, the use of pictures in this case should be more cautious.</div>
        </div>
        <h2>Disclaimer</h2>
        <div class="block" style="padding-bottom: 48px;">
          <div class="text">The User acknowledges and agrees that the Output of AI Generated Content is generated by artificial intelligence technology. KakaClo Company does not select, examine, control, guarantee, approve, sponsor or identify itself in any form with the AI Generated Content. The images generated by AI do not represent our attitudes or opinions.</div>
          <div class="text">Our services come from the accumulation of information permitted by laws and regulations, including but not limited to the public Internet, and have undergone continuous automatic and manual filtering of sensitive data. But, it is still not ruled out that some of the images are flawed, unreasonable or provokes unpleasantness. In such cases, please feel free to contact KakaClo for improvement.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.ai-alert {
  background: #F7F8FB;
  width: 100%;
  height: 100%;
  div, p {
    box-sizing: border-box;
  }

  .head {
    height: 64px;
    box-shadow: 0 10px 20px #E1E4EA;
    padding: 0 20px;
    .title {
      color: #303133;
      font-size: 18px;
    }
  }

  .content {
    margin: 20px;
    box-shadow: 0px 8px 24px 2px rgba(0,0,0,0.1);
    padding: 48px 0;
    overflow-y: auto;
    overflow-x: hidden;

    .main {
      width: 1160px;
      margin: 0 auto;
      padding: 0 20px;
      height: calc(100vh - 200px);

      h1 {
        font-size: 26px;
        font-weight: bold;
        margin-bottom: 40px;
      }

      h2 {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .block {
        margin-bottom: 36px;
        line-height: 20px;
      }
      .text {
        margin-bottom: 16px;
        color: #606266;
      }
      p {
        margin: 0;
        padding: 0;
        color: #606266;
        margin-bottom: 4px;
      }
    }

    .block {
      color: #303133;
    }
  }
}
</style>
